import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

const  ErrorQueryBoundary = ({ children, fallback, errorFallback }) => {
  return (
    <ErrorBoundary fallback={errorFallback}>
      <Suspense fallback={fallback}>
        {children}
      </Suspense>
    </ErrorBoundary>
  );
}

export default ErrorQueryBoundary